
<template>
    <div ref="listWrap">
        <wrapper-list
                @add="paasAddPage"
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import CellBar from '@components/paas/cell-bar'; //列表内操作
    import {changeDiyStatus} from "@api/order.js";
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList,EnumShow  ,CellBar},
        data() {
            return {
                serviceUrl:"/eb/diy",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    queryOrderBy_: 'dealStatus@DESC;createTime@DESC',
                },
                defaultLabelWidth:200,
                tableColumns:[
                    {
                        title: '咨询时间',
                        key: 'createTime',
                    },
                    {
                        title: '联系人',
                        key: 'realName',
                    },
                    {
                        title: '团购数量',
                        key: 'number',
                    },
                    {
                        title: '团队性质',
                        key: 'features',
                    },
                    {
                        title: '用途',
                        key: 'purpose',
                    },
                    {
                        title: '详细描述',
                        key: 'detaildesc',
                        ellipsis:true
                    },
                    {
                        title: '处理人',
                        key: 'dealName',
                        width:100,
                    },
                    {
                        title: '处理时间',
                        key: 'updateTime',
                    },
                    {
                        title: '操作',
                        render: (h, params) => {
                            let statusOperate = [];
                            let auditBtn = h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                                title: "客户电话",
                                                content: params.row.phone,
                                                okText: "确定",
                                                cancelText: "取消",
                                                onOk: () => {
                                                    this.updateStatus(params.row.id);
                                                },
                                                onCancel: () => {
                                                    this.$Message.info('Cancel Add Delay Modal');
                                                }
                                            });
                                       
                                    }
                                }
                            }, "处理");
                           
                            let detailBtn = h('Button', {
                                props: {
                                    size: 'small',
                                    disabled:true
                                },
                                on: {
                                    
                                }
                            }, '已处理');
                            //待发货
                           
                            if(params.row.dealStatus == 0){
                                statusOperate.push(auditBtn);
                            }else if(params.row.dealStatus == 1){
                                statusOperate.push(detailBtn);
                            }
                            return h('div',statusOperate);
                        }
                    }
                ],
            }
        },
        mounted(){
        },
        methods:{
            /**
             * 是否上架保存
             * @param row
             */
             updateStatus(id){
                let param = {
                    id:id,
                }
                changeDiyStatus(param).then(res=>{
                    if(res.code==200){
                        this.$Message.info("已更新客户状态!")
                        this.queryTableDatas();
                    }
                })
            }
        }
    }
</script>
